import React, { useEffect, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';
import states from 'src/util/states.json';
import {
  useCurrentLoanOfficer,
  useLoanOfficerForLoanValidLicenses,
  useLoanAssociates,
  useLoanOfficerAssociateForLoan,
  useLoanOfficerForLoan,
} from 'src/hooks';
import Empty from 'src/components/baseComponents/Empty';
import Loading from 'src/components/baseComponents/Loading';
import Icon from '@mdi/react';
import { mdiAlert } from '@mdi/js';
import { useFormContext } from 'react-hook-form';

const LoanPropertyContainer = ({ children }) => {
  const { loanGuid } = useParams();
  const loanAssociates = useLoanAssociates(loanGuid);
  const currentLoanOfficer = useCurrentLoanOfficer();
  const loanOfficerAssociateForLoan = useLoanOfficerAssociateForLoan(loanGuid);
  const loanOfficerForLoan = useLoanOfficerForLoan(loanGuid);
  const licenses = useLoanOfficerForLoanValidLicenses(loanGuid);
  const { trigger } = useFormContext();
  const triggered = useRef(false);
  const statesOptions = useMemo(() => {
    return states.filter((x) => licenses.some((lic) => lic.state === x.value));
  }, [licenses]);
  const canTrigger = Boolean(
    loanAssociates.length &&
    loanOfficerAssociateForLoan?.loanOfficerId &&
    loanOfficerForLoan &&
    statesOptions?.length,
  );

  useEffect(() => {
    if (canTrigger && !triggered.current) {
      triggered.current = true;
      trigger();
    }
  }, [canTrigger, trigger]);
  return !loanAssociates.length ? (
    <Loading label='Loading loan officer...' />
  ) : !loanOfficerAssociateForLoan ? (
    <Empty
      icon={<Icon path={mdiAlert} />}
      text={(
        <span>
          Loan has no loan officer.
          <br />
          You cannot enter property information until a loan officer is
          assigned.
        </span>
      )}
    />
  ) : loanOfficerAssociateForLoan?.loanOfficerId === 0 ? (
    <Empty
      icon={<Icon path={mdiAlert} />}
      text={(
        <span>
          Loan officer does not have a Cinch account.
          <br />
          You cannot enter property information until they create an account.
        </span>
      )}
    />
  ) : loanOfficerForLoan?.licenses === undefined ? (
    <Loading label='Loading licenses...' />
  ) : !statesOptions?.length ? (
    <Empty
      icon={<Icon path={mdiAlert} />}
      text={`${
        currentLoanOfficer?.id === loanOfficerForLoan?.id
          ? 'You are'
          : `${
              loanOfficerForLoan?.name ??
              loanOfficerForLoan?.encompassUser ??
              'The LO'
            } is`
      } not licensed for any states.`}
    />
  ) : (
    children({ states: statesOptions })
  );
};

export default LoanPropertyContainer;
